export default "__VITE_ASSET__C9n2g65n__"